
import { IOpen } from "@/utils/chart-open";
import Vue from "vue";
import AppOpenByMonth from "./OpenByMonth.vue";
import {ChartService} from "@/services";

export default Vue.extend({
	data(){
		return {
			open: null as null | IOpen
		};
	},
	methods: {
		async fetch(){
			this.open = await ChartService.getOpen();
		},
	},
	mounted(){
		this.fetch();
	},
	components: {
		AppOpenByMonth
	},
	i18nEx: {
		componentPrefix: "views.HomeRoute"
	}
});
